// Spec 078 FR-029 — "Sem atualização desde HH:mm": a cena deixa de se apresentar como ao vivo
// quando o último dado tem mais de SCENE_STALE_MS. Reavalia a cada 5 s (não depende de um
// novo fetch para envelhecer — é exatamente quando o fetch parou que isto importa).
import * as React from "react";
import { SCENE_STALE_MS } from "@opus-dt/shared-types";

export interface Staleness {
  stale: boolean;
  /** instante do último dado bom; null enquanto nunca houve dado */
  since: Date | null;
}

const TICK_MS = 5_000;

export function useStaleness(dataUpdatedAt: number, thresholdMs = SCENE_STALE_MS): Staleness {
  const [now, setNow] = React.useState(() => Date.now());

  React.useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), TICK_MS);
    return () => window.clearInterval(id);
  }, []);

  if (!dataUpdatedAt) return { stale: false, since: null };
  return {
    stale: now - dataUpdatedAt > thresholdMs,
    since: new Date(dataUpdatedAt),
  };
}

// Construir um Intl.DateTimeFormat é ~40× mais caro que usá-lo, e `formatSince` roda por máquina
// a cada re-render da cena — o formatador vive no módulo.
const hhmm = new Intl.DateTimeFormat("pt-BR", { hour: "2-digit", minute: "2-digit" });

export function formatSince(date: Date | null): string {
  // Data inválida é truthy: sem esta guarda, `format` lança RangeError DENTRO do render e a cena
  // inteira cai no CrashFallback por causa de um carimbo torto de uma máquina.
  if (!date || Number.isNaN(date.getTime())) return "—";
  return hhmm.format(date);
}
